import { useEffect, useState, useMemo } from "react";
import React from 'react';
import ReactTableWrapper from "../../components/ReactTableWrapper";
import { exportAsCSV } from "../../utils/CSVExporter";
import { exportAsPDF } from "../../utils/PDFExporter";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import Swal from "sweetalert2";
import { useCookies } from 'react-cookie';
import {Row, Col, Button} from "reactstrap";
import { default as ReactSelect } from "react-select";
import {getUserReport,getUserReportCSV} from "../../services/ReportServices";
import {  DatePicker } from 'antd';
import { getAllUsers} from "../../services/UserServices";
import moment  from 'moment';
import {displayErrorToast,displayError,parseBoolean,parseBooleanToString} from '../../helpers';
import {HandleSelect,ValueContainer,Option} from "../../components/MultiSelectControls";
import ReportExportDropdown from '../../components/ReportExportDropdown';
import ReportFilterToggleBar from '../../components/ReportFilterToggleBar';
const {RangePicker} = DatePicker;

function UserReport() 
{
    const InitialData = {
        total_pages: 0,
        records: [],
      };
    const [data, setData] = useState(InitialData);
    const navigate = useNavigate(); 
    const [cookies] = useCookies(['myToken']);
    const [isLoading, setIsLoading] = useState(false);
    const [users, setUsers] = React.useState([]);
    const [selectedUser, setSelectedUser] = useState([]);
    const [uniqueUsers, setUniqueUsers] = useState(0);
    const [uniqueModules, setUniqueModules] = useState(0);
    const [filtersVisible, setFiltersVisible] = useState(true);
    // const [inputs, setInputs] = useState({});

    // Initial state for from_date and to_date
    const initialFromDate = moment().startOf('month');
    const initialToDate =  moment();
    const [fromDate, setFromDate] = useState(initialFromDate);
    const [toDate, setToDate] = useState(initialToDate);
    const handleDateChange = (values) => {
        if ((values) && (values.length === 2)) {
        setFromDate(values[0]);
        setToDate(values[1]);
        }
    };

    React.useEffect(() => {
        //Load data for Plant dropdown
        getAllUsers(cookies)
        .then (
            userList => {
                const users = userList.user_list.map(
                    user => {
                        return { value: user.user, label: user.username }
                    }
                );
                setUsers(users);
                setSelectedUser(values =>[...values,...users, ...usersWithSelectAll]);
            }
        )
    }, []);

    // Add a "Select All" option to the users array
    const usersWithSelectAll = [
        { value: "select-all", label: "Select All Users" },
        ...users,
    ];

    const onUserSelect = (selected) => {
        HandleSelect(selected,selectedUser,setSelectedUser, users, usersWithSelectAll);
    };

    const areAllUsersSelected = () => {
        // Check if all plants are selected
        console.log(JSON.stringify(users)+"users");
        console.log(JSON.stringify(selectedUser)+"selectedUser");
        // Check if users array is empty
        if (users.length === 0) {
            return false;
        }
        return users.every((user) =>
            selectedUser ? selectedUser.some((selected) => selected.value === user.value) : false
        );
    };

    const Home = () => {
        navigate('/Home')
    }
    
    const left_pinned = ["content_type"]
    const right_pinned = ["user_name"]
    
    const columns = useMemo(
        () => [
            {
                fieldName: 'user_ip_addr', 
                headerName: 'IP Address'
            },
            {
                fieldName: 'content_type', 
                headerName: 'Content Type'
            },
            {
                fieldName: 'action_done', 
                headerName: 'Action Done'
            },
            {
                fieldName: "sl_no",
                headerName: 'Sl No'
            },
            {
                fieldName: 'module_name', 
                headerName: 'Module Name'
            },
            {
                fieldName: "tracking_dtm",
                headerName: 'Tracking Datetime'
            },
            {
                fieldName: 'plant', 
                headerName: 'Plant/Company Name'
            },
            {
                fieldName: "user_name",
                headerName: 'User Name'
            },
            {
                fieldName: "location",
                headerName: 'Location'
            }
        ],
        [],);
   
    const handleCSVExport = (event) => {
    };

    const handlePDFExport = (event) => {
    };

    const constructFormData = () => {
        console.log(JSON.stringify(areAllUsersSelected())+"areAllUsersSelected constructFormData")
        const EMPTY_STRING = '';
        return {
            user_ids:areAllUsersSelected()? '*' // Send '*' if all users are selected
            : selectedUser.map((user) => user.value).join(','),
            from_date:fromDate.format('DD-MM-YYYY'),
            upto_date:toDate.format('DD-MM-YYYY')
          }
    }
    const handleDownloadCsv = () => {
        // console.log(JSON.stringify(constructFormData())+"submit")
        const inputs = constructFormData()
        if ((inputs.user_ids)  &&
        (inputs.from_date) && (inputs.upto_date))
        {
            getUserReportCSV(cookies, constructFormData())
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'user_report.csv');
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            })
            .catch((error) => {
                console.log(error.response.data);
                displayError(error.response.data);
            });
        }
        else 
        {
            Swal.fire("user,from_date,upto_date must not be empty.", "", "info");  
        }
    };

    const handleGenerate = () => {
        const formData = constructFormData();
        if ((formData.user_ids) && (formData.from_date) && (formData.upto_date))
        {
            setIsLoading(true);
            getUserReport(cookies, formData)
            .then(response => {
                const tableData = (response.user_report_list || [])
                .map(user => ({
                    id:user.id,
                    user_ip_addr: user.user_ip_addr,
                    content_type: user.content_type,
                    action_done: user.action_done,
                    sl_no: user.sl_no,
                    module_name:user.module_name,
                    tracking_dtm: user.tracking_dtm,
                    plant: user.plant,
                    user_name: user.user_name,
                    location: user.location
                }));
                setData({ records: tableData });
                setUniqueUsers(new Set(tableData.map((row) => row.user_name).filter(Boolean)).size);
                setUniqueModules(new Set(tableData.map((row) => row.module_name).filter(Boolean)).size);
                setFiltersVisible(false);
                setIsLoading(false);
            }).catch((error) => {
                console.log(error);
                displayError(error?.response?.data || error, 'Load Failed');
                setIsLoading(false);
            });
        }
        else
        {
            setData({ records: [] });
            setUniqueUsers(0);
            setUniqueModules(0);
            Swal.fire("user,from_date,upto_date must not be empty.", "", "info");
        }
    };

    const handleSubmit=(event)=>
    {
        event.preventDefault();
        handleGenerate();
    }

    return (
            <div className="report-embedded-page">
                {!filtersVisible ? (
                    <div className="container">
                        <ReportFilterToggleBar onShow={() => setFiltersVisible(true)} />
                    </div>
                ) : null}
                {filtersVisible ? (
                <form className="form" onSubmit={handleSubmit}>
                    <div className="container"> 
                        <Row> 
                            <Col xl={12} lg={12} md={12}>
                                <div className="report-legacy-filters form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel">
                                        <div className="report-legacy-filters-fields">
                                        <ReactSelect
                                            options={usersWithSelectAll}
                                            isMulti={true}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            components={{Option, ValueContainer}}
                                            isClearable={true}
                                            value={selectedUser}
                                            onChange={onUserSelect}
                                            className="react-select-dropdown col-sm-3"
                                            placeholder="Please select User"
                                        />
                                        </div>
                                        <div className="report-legacy-filters-row">
                                        <RangePicker
                                            defaultValue={[initialFromDate, initialToDate]}
                                            format="DD-MM-YYYY"
                                            onChange={handleDateChange}
                                            style={{width:"270px"}}
                                        />
                                        <div className="report-legacy-actions">
                                        <ReportExportDropdown
                                            onCSV={handleDownloadCsv}
                                            disabled={isLoading}
                                        />
                                        <Button
                                            color="primary"
                                            className="list-page-toolbar-generate-btn"
                                            type="button"
                                            onClick={handleGenerate}
                                            disabled={isLoading}
                                        >
                                            Generate
                                        </Button>
                                        </div>
                                        </div>
                                </div>
                             </Col>
                        </Row>
                    </div> 
                </form>
                ) : null}
                <div className="container">
                        {data.records.length > 0 ? (
                                <div className="list-page-summary-bar">
                                    <div className="list-page-summary-primary">
                                        <span className="list-page-summary-label">FILTERED VIEW</span>
                                        <span className="list-page-summary-count">
                                            {data.records.length} {data.records.length === 1 ? 'activity' : 'activities'}
                                        </span>
                                    </div>
                                    <div className="list-page-summary-metrics">
                                        <div className="list-page-metric-card">
                                            <span className="list-page-metric-label">Users</span>
                                            <span className="list-page-metric-value is-yellow">{uniqueUsers}</span>
                                        </div>
                                        <div className="list-page-metric-card">
                                            <span className="list-page-metric-label">Modules</span>
                                            <span className="list-page-metric-value">{uniqueModules}</span>
                                        </div>
                                        <div className="list-page-metric-card">
                                            <span className="list-page-metric-label">Activities</span>
                                            <span className="list-page-metric-value is-b2b">{data.records.length}</span>
                                        </div>
                                    </div>
                                </div>
                        ) : null}
                    <div className="list-page-table-wrap">
                        <div className="item-list-table-container">
                            <div className="table-responsive">
                                <ReactTableWrapper
                                    title='User Report'
                                    columns={columns}
                                    data={data.records}
                                    exportFilename="user_report"
                                    isLoading={isLoading}
                                    left_pinned={left_pinned}
                                    right_pinned={right_pinned}
                                    enableTableSearch={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
);
}

export default UserReport;